module.exports = __webpack_public_path__ + "img/emoji_33.47f5df9f.png";